import Contact from "components/Contactanos/Contact";
import React from "react";

function Contacto() {
  return (
    <section className="bg-secundario">
      <div className="flex flex-row  items-end">
        <div className="w-1/2 h-full overflow-hidden rounded-l-none rounded-30">
          <img
            src="https://brightonenglishcenter.edu.co/img/Instalaciones.jpg"
            alt="Brighton Centro de Ingles, el puente a tu futuro."
            className="object-cover w-full h-full object-top"
          />
        </div>
        <div className="w-1/2 flex flex-col gap-10 p-20 text-primario">
          <div className="text-2xl text-center">
            <h1 className="text-9xl font-Bebas font-bold tracking-wider">
              Contáctanos
            </h1>
            <p>
              <strong>
                ¡Gracias por tu interés en Brighton Centro de Inglés!
              </strong>{" "}
              Estamos aquí para responder todas tus preguntas y ayudarte en tu
              proceso de formación.
            </p>
          </div>
          <Contact />
          <div className="w-full grid grid-cols-2 gap-5">
            <div className="text-xl">
              <h2 className="text-3xl font-Bebas font-bold tracking-wider mb-2 ">
                Visítanos
              </h2>
              <p>Pasto, Colombia, Carrera 38 # 19-26, Barrio Palermo.</p>
            </div>
            <div className="text-xl">
              <h2 className="text-3xl font-Bebas font-bold tracking-wider mb-2 ">
                Horarios de Atención
              </h2>
              <div className="flex flex-row gap-5 justify-between ">
                <p>
                  <strong>Lunes y viernes</strong>
                </p>
                <p>8:00 a.m. - 8:30 p.m.</p>
              </div>
              <div className="flex flex-row gap-5 justify-between">
                <p>
                  <strong>Sabados</strong>
                </p>
                <p>8:00 a.m. - 1:00 p.m.</p>
              </div>
            </div>
            <div className="text-xl">
              <h2 className="text-3xl font-Bebas font-bold tracking-wider mb-2">
                Numeros de contacto
              </h2>
              <div className="flex flex-row gap-5 justify-between">
                <p>
                  <strong>Oficina principal</strong>
                </p>
                <p>(602) 721 07 51</p>
              </div>
              <div className="flex flex-row gap-5 justify-between">
                <p>
                  <strong>Academico</strong>
                </p>
                <p>+57 318 3163984</p>
              </div>
              <div className="flex flex-row gap-5 justify-between">
                <p>
                  <strong>Examenes</strong>
                </p>
                <p>+57 318 5289302</p>
              </div>

              <div className="flex flex-row gap-5 justify-between">
                <p>
                  <strong>Ventas</strong>
                </p>
                <p>+57 316 8664459</p>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-Bebas tracking-wider font-bold mb-2 text-center">Siguenos En</h2>
              <div className="flex justify-center gap-5">
                <a href="https://www.facebook.com/BrightonPasto">
                  <i class=" fa-brands fa-facebook-f text-5xl hover:text-yellow-1 duration-200" />
                </a>
                <a
                  href="https://www.instagram.com/brightonpasto"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class=" fa-brands fa-instagram text-5xl hover:text-yellow-1 duration-200"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@brightonenglishcenterpso?_t=8q9oVimXZDR&_r=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class=" fa-brands fa-tiktok text-5xl hover:text-yellow-1 duration-200"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="">
            {/* <p>
              Si tienes alguna pregunta específica o necesitas información
              adicional sobre nuestros cursos, servicios corporativos o
              cualquier otro tema relacionado con Brighton Centro de Inglés, no
              dudes en contactarnos. Estamos aquí para ayudarte.
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contacto;
